import { Button, Flex, Heading, HStack, Image, Text } from '@chakra-ui/core';
import { ChevronLeftIcon } from '@chakra-ui/icons';
import React from 'react';
import ElectionEventImage from '../../assets/election_event.svg';
import PriceEventImage from '../../assets/price_event.png';
import { ELECTION_BETTING_END_DATE } from '../../utils/Election';

const EventTypeSelect = ({
  image,
  label,
  onClick,
  disabledText = '(Coming Soon)',
  ...props
}) => {
  return (
    <Flex
      flexDir="column"
      alignItems="center"
      justifyContent="center"
      border="solid 1px #929292"
      h="135px"
      w="150px"
      flexShrink={0}
      borderRadius="4px"
      p={3}
      cursor={!props.disabled ? 'pointer' : 'initial'}
      opacity={!props.disabled ? 1 : 0.5}
      onClick={!props.disabled && onClick}
    >
      <Image src={image} maxH="50px" mb={2} />
      <Text fontWeight="bold">{label}</Text>
      {props.disabled && <Text fontSize="xs">{disabledText}</Text>}
    </Flex>
  );
};

const BetEventSelection = ({ onBack, onEventSelection }) => {
  return (
    <>
      <Heading size="md" as="h4" textAlign="center" mb={8}>
        What do you want to bet on?
      </Heading>

      <HStack justifyContent="center" spacing={8}>
        <EventTypeSelect
          onClick={onEventSelection}
          image={PriceEventImage}
          label="Crypto Price"
          disabled
        />
        <EventTypeSelect
          onClick={onEventSelection}
          image={ElectionEventImage}
          label="US Election"
          disabled={new Date() > ELECTION_BETTING_END_DATE}
          disabledText="(Closed)"
        />
      </HStack>

      <Flex flexDir="row" mt={8}>
        <Button
          alignSelf="flex-end"
          leftIcon={<ChevronLeftIcon />}
          onClick={onBack}
        >
          Go Back
        </Button>
      </Flex>
    </>
  );
};

export default BetEventSelection;
